import { render, staticRenderFns } from "./pageHeaderBtn.vue?vue&type=template&id=2698c465&scoped=true&"
import script from "./pageHeaderBtn.vue?vue&type=script&lang=js&"
export * from "./pageHeaderBtn.vue?vue&type=script&lang=js&"
import style0 from "./pageHeaderBtn.vue?vue&type=style&index=0&id=2698c465&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2698c465",
  null
  
)

export default component.exports